import React from "react";
import styles from "./GeneralChips.module.css";

export default function GeneralChips({ title, handleClick, selectedChips }) {
  const isSelected = selectedChips.includes(title);

  return (
    <button
      type="button"
      className={`${styles.chip_container} ${isSelected ? styles.active : ""}`}
      onClick={handleClick}
      aria-pressed={isSelected}
      aria-label={`Filter by ${title}`}
    >
      <span>{title}</span>
    </button>
  );
}
